var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheck = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8665 3.31853C13.9952 2.48475 11.9046 2.2782 9.90637 2.72967C7.90814 3.18115 6.10938 4.26646 4.77836 5.82375C3.44734 7.38104 2.65538 9.32687 2.52059 11.371C2.38579 13.4152 2.9154 15.4482 4.03041 17.1667C5.14542 18.8853 6.78609 20.1974 8.70774 20.9074C10.6294 21.6173 12.7291 21.6871 14.6936 21.1062C16.6581 20.5254 18.3823 19.3251 19.6089 17.6843C20.8355 16.0435 21.4988 14.0501 21.5 12.0015V11.0818C21.5 10.8057 21.7239 10.5818 22 10.5818C22.2761 10.5818 22.5 10.8057 22.5 11.0818V12.0018C22.4987 14.2661 21.7655 16.4695 20.4098 18.283C19.0541 20.0965 17.1484 21.4232 14.9771 22.0652C12.8058 22.7072 10.4851 22.6301 8.36119 21.8454C6.23726 21.0607 4.42388 19.6105 3.1915 17.711C1.95912 15.8115 1.37377 13.5646 1.52275 11.3052C1.67173 9.0459 2.54706 6.89525 4.01819 5.17403C5.48931 3.45281 7.47742 2.25326 9.68599 1.75426C11.8946 1.25526 14.2053 1.48356 16.2735 2.4051C16.5257 2.51749 16.6391 2.81308 16.5267 3.06532C16.4143 3.31755 16.1187 3.43092 15.8665 3.31853Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3534 3.64627C22.5487 3.84143 22.5489 4.15802 22.3537 4.35338L12.3537 14.3634C12.26 14.4572 12.1328 14.51 12.0001 14.51C11.8675 14.51 11.7402 14.4574 11.6464 14.3636L8.64645 11.3636C8.45118 11.1683 8.45118 10.8517 8.64645 10.6564C8.84171 10.4612 9.15829 10.4612 9.35355 10.6564L11.9998 13.3027L21.6463 3.64662C21.8414 3.45126 22.158 3.45111 22.3534 3.64627Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/check.2a80ef2036222f9ca6e21a521ef58efd.svg";